import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { SensitivityAnalysisParams } from '../types';

interface DispatchResponse {
    taskId: string;
}

interface DispatchArgs {
    dealId: number;
    proFormaId: number;
    params: SensitivityAnalysisParams;
    sourceId: number | null;
}

const dispatchSensitivityAnalysis = async ({
    dealId,
    proFormaId,
    params,
    sourceId,
}: DispatchArgs): Promise<DispatchResponse> => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.PRO_FORMA_SENSITIVITY_ANALYSIS(dealId, proFormaId),
        {
            parameters: params.parameters,
            firstParameterStepMultiplier: params.firstParameterStepMultiplier || 1,
            secondParameterStepMultiplier: params.secondParameterStepMultiplier || 1,
            sourceId,
        },
    );
    return response.data;
};

const useDispatchSensitivityAnalysis = () => useMutation({
    mutationFn: dispatchSensitivityAnalysis,
});

export default useDispatchSensitivityAnalysis;
